import { ISelectableListItem } from '@andromeda/calvera-prototype-multi-retailer-cart-data-access-store';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
})

export default class Checkbox extends Vue {
    @Prop({ required: true }) listItem!: ISelectableListItem;
}
